import React, { useEffect, useState, useContext } from 'react';
import { QtcRenderer, KeypadContext } from '@3plearning/question-components-library';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import { t } from '@lingui/macro';

import { MODULE_NAME_ACTIVITY } from '../../helpers/constants';
import {
  disableSpinner,
  ACTIVITY_RENDER_SPINNER
} from '../mle/mle-actions';
import { updateAnswer } from './conquest.actions';
import css from './conquest.scss';
import { useLocalisation } from '../../helpers/i18n/use-localisation';
import { randomiseQuestionMCQOptions } from '../../helpers/utils';

const Conquest = () => {
  const { i18n } = useLocalisation();
  const dispatch = useDispatch();
  const [question, setQuestion] = useState([]);
  const { initMleReducer, conquestReducer, queryStringReducer } = useSelector(state => state);
  const {
    keypadRef, questionBodyElement
  } = useContext(KeypadContext);
  const keypadPresetFromQueryParams = queryStringReducer.keypadPreset;
  let activityData;

  const feedback = ({ answer, isReady }) => {
    dispatch(updateAnswer({ answer, isReady }));
  };

  useEffect(() => {
    dispatch(disableSpinner(ACTIVITY_RENDER_SPINNER));

    if (initMleReducer.length > 0) {
      activityData = initMleReducer.find(item => item.meta.name === MODULE_NAME_ACTIVITY);
      setQuestion(
        randomiseQuestionMCQOptions(activityData.questionDetails.questionVariant.questionItem.questionContent.content)
      );
    }

    if (activityData.data) {
      dispatch(updateAnswer({
        answer: activityData.data.studentAnswer,
        isReady: false,
        validation: activityData.data.validationResult
      }));
    }
  }, []);

  return (
    <div id={'new-content-container'}>
      {keypadRef.current && <QtcRenderer
        question={question}
        callback={feedback}
        validation={conquestReducer.validation}
        keypadPreset={
          keypadPresetFromQueryParams ? Number(keypadPresetFromQueryParams) : 3
        }
        keypadContainer={keypadRef.current}
        userResponse={conquestReducer.answer}
        scrollableContainer={questionBodyElement}
      />}
      {
        conquestReducer.validation && !conquestReducer.validation.isCorrect && (
          <Box className={css['correct-answer']} >
            <Text className={css['correct-answer-text']} >
              {i18n._(t`Here's the correct answer`)}
            </Text>
            <Box className={css['correct-answer-container']}>
              <QtcRenderer
                callback={() => undefined}
                question={question}
                showCorrectAnswer
                validation={conquestReducer.validation}
              />
            </Box>
          </Box>
        )
      }
    </div>
  );
};

export default Conquest;
